<template>
    <div class="relative text-primary">
        <select
            v-model="model"
            :aria-label="label"
            class="block appearance-none w-full bg-white border border-grey-light px-4 py-2 pr-8 leading-tight">
            <option v-if="placeholder" :value="null" disabled>{{ placeholder }}</option>
            <option v-for="option in options" :value="option.value">{{ option.label }}</option>
        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
            <svg class="fill-current h-4 w-4" viewBox="0 0 20 20"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
            </svg>
        </div>
    </div>
</template>

<script>

export default {

    props: {
        value: {
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        placeholder: String,
        label: String,
    },

    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};

</script>
